// app/javascript/controllers/admissoes/approvals_controller.js
import { Controller } from "@hotwired/stimulus";
import { initAdmissoesBulkApproval } from "../../modules/admissoes/bulk_approval";
import { createAdmissoesApprovalsService } from "../../services/admissoes_approvals_service";

export default class extends Controller {
  static values = {
    bulkUrl: String,
  };

  connect() {
    console.log("AdmissoesApprovalsController conectado. Bulk URL:", this.bulkUrlValue);

    this.service = createAdmissoesApprovalsService({
      bulkUrl: this.bulkUrlValue,
    });

    this.bulk = initAdmissoesBulkApproval(this.element, this.service);
  }

  disconnect() {
    this.bulk?.destroy?.();
  }
}
